import { TypeAnimation } from 'react-type-animation';
import Contact from '../anexo/contact';

import AlfeuX from '../img/AlfeuX.jpg';

export default function Profile(){
    return(
        <section className='profile'>
          <div className='me'>
            <div>
              <h2>
                <TypeAnimation
                  sequence={[
                    "Software Development Engineer", 3000,
                    "UX/UI Design enthusiast", 3000,
                    "Freelancer", 3000,
                  ]}
                  speed={50}
                  style={{ fontSize: '.9em' }}
                  repeat={Infinity}
                />
              </h2>
              <h1> Alfeu Xerinda </h1>
              <h4> {"(Hard.0_0.7)"} </h4>
            </div>
            <div>
              <p>
                <i>Get in touch with me to build your: </i>
                <h3>
                  <TypeAnimation
                    sequence={[
                      "Website", 3000,
                      "WebApp", 3000,
                      "Software", 3000,
                    ]}
                    speed={50}
                    style={{ fontSize: '.9em' }}
                    repeat={Infinity}
                  />
                </h3> 
              </p>
            </div>
            <Contact/>
          </div>
          <div className='me-selfie'>
            <img src={AlfeuX} alt='Alfeu`s selfie' />
          </div>
        </section>
    );
}